export const MESSAGE_TYPE = {
  sms: 'SMS',
  mms: 'MMS',
  unknown: 'UNKNOWN'
};

export const MESSAGE_STATE = {
  send: 'SEND',
  progress: 'PROGRESS',
  receive: 'RECEIVE',
  read: 'READ',
  change: 'CHANGE',
  delete: 'DELETE'
};

export const MESSAGE_STATUS = {
  unknown: 'UNKNOWN',
  queued: 'QUEUED',
  inProcess: 'INPROCESS',
  delivered: 'DELIVERED',
  error: 'ERROR'
};

export const MESSAGE_DIRECTION = {
  outbound: 'OUTBOUND'
}

export const MESSAGE_SETUP = {
  EVENT_MAX_DIFF_TIME_MS: 15000,
  MAX_PROVIDER_SMS_LENGTH: 250,
  MAX_PROVIDER_MMS_LENGTH: 700,
}

// Message lifecycle.

// messageState: "SEND"           .
// messageStatus: "INPROCESS"
//
// messageState: "PROGRESS"       ..
// messageStatus: "DELIVERED"
//
// messageState: "RECEIVE"        ...
// messageStatus: "DELIVERED"
//
// messageState: "READ"           ....
// messageStatus: "DELIVERED"


// Other scenarios.

// messageState: "PROGRESS"
// messageStatus: "ERROR"
